import type { Ref } from 'vue'
import type { LocalizableResource } from '~/composables/types/localizable'
import { useResolvedEventListPage } from '~/composables/transactionalPage/useResolvedEventListPage'
import { useEventListPageSlugs } from '~/composables/transactionalPage/useEventListPageSlugs'
import { useEventListPageType } from '~/composables/transactionalPage/useEventListPageType'
import { useResolvedMagazinePage } from '~/composables/magazine/useResolvedMagazinePage'
import { isMagazineArticlePage, isEventListPage } from '~/utils/routeHelpers'

type PageResourceResult = ReturnType<
  typeof useAsyncData<LocalizableResource | null | undefined, Error | undefined>
>

export const useCurrentPageResource = (): PageResourceResult => {
  const route = useRoute()

  if (isMagazineArticlePage(route)) {
    const slug = route.params.articleSlug?.toString()
    return useResolvedMagazinePage(slug) as unknown as PageResourceResult
  }

  if (isEventListPage(route)) {
    const pageType = useEventListPageType()
    const { citySlug, categorySlug, generalSlug } =
      useEventListPageSlugs(pageType)
    return useResolvedEventListPage({
      pageType,
      slug: generalSlug,
      citySlug,
      categorySlug,
    }) as unknown as PageResourceResult
  }

  return useAsyncData<
    LocalizableResource | null | undefined,
    Error | undefined
  >('page-resource-none', () => Promise.resolve(null))
}

export type { PageResourceResult }
export type PageResource = Ref<LocalizableResource | null | undefined>
